import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  systemConfigurationController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$state',
    'authService',
    'systemConfigService',
    'ECodeOptionsType',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $state,
      authService,
      systemConfigService,
      ECodeOptionsType
    ) {
      'use strict';

      function getValue(type) {
        switch (type) {
          case ECodeOptionsType.Folder:
            return 'ADM';
          case ECodeOptionsType.DocumentType:
            return 'PROP';
          case ECodeOptionsType.Sequence:
            $scope.hasSequencial = true;
            return 125;
          case ECodeOptionsType.RevisionNumber:
            return 2;
          case ECodeOptionsType.RevisionYear:
            return new Date().getFullYear();
          case ECodeOptionsType.Extension:
            return 'pdf';
          default:
            break;
        }
      }

      function validateMaskValues(values) {
        if (values.length === 0) {
          return {
            title: $filter('translate')('NO VALUE SELECTED'),
            text: $filter('translate')('SELECT ANY VALUE'),
          };
        }

        var selectedValues = [
          $scope.configuration.values.value0,
          $scope.configuration.values.value1,
          $scope.configuration.values.value2,
          $scope.configuration.values.value3,
          $scope.configuration.values.value4,
          $scope.configuration.values.value5,
        ];

        for (var pos = 1; pos < selectedValues.length; pos++) {
          if (
            selectedValues[pos].type !== 0 &&
            selectedValues[pos - 1].type === 0
          ) {
            return {
              title: $filter('translate')('INCORRECT ORDER'),
              text: $filter('translate')('USE VALUES IN SEQUENCE'),
            };
          }
        }

        var qualityRegex = /{.*?}/g;
        var sequences = [];
        var matches = qualityRegex.exec($scope.configuration.codeFormat);

        while (matches) {
          sequences.push(matches[0]);
          matches = qualityRegex.exec($scope.configuration.codeFormat);
        }

        if (sequences.length !== values.length) {
          return {
            title: $filter('translate')('DIFFERENT VALUES'),
            text: $filter('translate')('NUMBER OF VALUES DIFFERENT'),
          };
        }

        try {
          $scope.code = String.format($scope.configuration.codeFormat, values);
          return null;
        } catch (error) {
          return {
            title: $filter('translate')('ERROR ON GENERATE CODE'),
            text: $filter('translate')(error.message),
          };
        }
      }

      function load() {
        $scope.loading = true;
        systemConfigService.load().then(function (data) {
          $scope.configuration = data;
          $scope.configuration.values = [];

          var value = $scope.codeOptions[data.value0];
          $scope.configuration.values['value0'] = value
            ? value
            : $scope.codeOptions[0];
          value = $scope.codeOptions[data.value1];
          $scope.configuration.values['value1'] = value
            ? value
            : $scope.codeOptions[0];
          value = $scope.codeOptions[data.value2];
          $scope.configuration.values['value2'] = value
            ? value
            : $scope.codeOptions[0];
          value = $scope.codeOptions[data.value3];
          $scope.configuration.values['value3'] = value
            ? value
            : $scope.codeOptions[0];
          value = $scope.codeOptions[data.value4];
          $scope.configuration.values['value4'] = value
            ? value
            : $scope.codeOptions[0];
          value = $scope.codeOptions[data.value5];
          $scope.configuration.values['value5'] = value
            ? value
            : $scope.codeOptions[0];

          $scope.testCode(false);

          $scope.loading = false;
        });
      }

      function isSysadmin() {
        return authService.isSysAdmin();
      }

      function tabTitle() {
        return $scope.selectedTab === 'geral'
          ? $filter('translate')('GENERAL SETTINGS')
          : $filter('translate')('CODE SETTINGS');
      }

      function optionsFilter(item, option) {
        if (item && item.name) {
          var confValue = $scope.configuration.values[option];
          if ((confValue && confValue.name === item.name) || item.type === 0) {
            return true;
          }

          for (var key in $scope.configuration.values) {
            if (key.indexOf('value') > -1 && key !== option) {
              var val = $scope.configuration.values[key];
              if (val && val.name === item.name) {
                return false;
              }
            }
          }
          return true;
        } else {
          return angular.equals(item, option);
        }
      }

      function testCode(showErrors) {
        $scope.code = '';
        $scope.hasCodeError = false;
        $scope.hasLogo = true;
        if ($scope.configuration.codeFormat) {
          var values = [];
          $scope.hasSequencial = false;
          if ($scope.configuration.values.value0.type !== 0) {
            values.push(getValue($scope.configuration.values.value0.type));
          }
          if ($scope.configuration.values.value1.type !== 0) {
            values.push(getValue($scope.configuration.values.value1.type));
          }
          if ($scope.configuration.values.value2.type !== 0) {
            var val = getValue($scope.configuration.values.value2.type);
            values.push(val);
          }
          if ($scope.configuration.values.value3.type !== 0) {
            values.push(getValue($scope.configuration.values.value3.type));
          }
          if ($scope.configuration.values.value4.type !== 0) {
            values.push(getValue($scope.configuration.values.value4.type));
          }
          if ($scope.configuration.values.value5.type !== 0) {
            values.push(getValue($scope.configuration.values.value5.type));
          }

          var error = {};

          if (!$scope.hasSequencial) {
            error = {
              title: $filter('translate')('NO SEQUENCE SELECTED'),
              text: $filter('translate')('NO SEQUENCE SELECTED'),
            };
          }

          if (!error.title) {
            error = validateMaskValues(values);
          }

          if (error) {
            if (showErrors) {
              swal.fire(error.title, error.text);
            } else {
              $scope.code = error.text;
              $scope.hasCodeError = true;
            }
            return false;
          } else {
            return true;
          }
        } else {
          swal.fire(
            $filter('translate')('FILL FORMAT'),
            $filter('translate')('FORMAT IS REQUIRED')
          );
          return false;
        }
      }

      function isSignEnabled() {
        var loggedCompany = authService.getLoggedCompany();
        return loggedCompany && loggedCompany.Company.CanSignFiles;
      }

      function save() {
        if ($scope.testCode(true)) {
          systemConfigService.save($scope.configuration).then(
            function () {
              //setar a configuração onde for usar futuramente
              $state.go('modules.forms');
            },
            function (error) {
              swal.fire({
                title: error.title,
                error: error.error,
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
            }
          );
        } else {
          $scope.selectedTab = 'codigo';
        }
      }

      function currentTab() {
        return $scope.selectedTab;
      }

      function updateTab(tab) {
        $scope.selectedTab = tab;
      }

      function cancel() {
        swal
          .fire({
            title: $filter('translate')('CANCEL'),
            text: $filter('translate')('CONFIRM CANCEL'),
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showCancelButton: true,
          })
          .then(function () {
            $state.go('modules.forms');
          });
      }

      function run() {
        try {
          $scope.title = $state.current.data.title;
          $scope.$parent.title = $scope.title;
          $scope.selectedTab = 'geral';
          $scope.hasSequencial = false;
          $scope.codeOptions = [];
          $scope.codeOptions[0] = {
            name: '-----',
            type: 0,
            selected: function () {
              return false;
            },
          };
          $scope.codeOptions[ECodeOptionsType.Folder] = {
            name: $filter('translate')('FOLDER ACRONYM'),
            type: ECodeOptionsType.Folder,
          };
          $scope.codeOptions[ECodeOptionsType.DocumentType] = {
            name: $filter('translate')('DOCUMENT TYPE ACRONYM'),
            type: ECodeOptionsType.DocumentType,
          };
          $scope.codeOptions[ECodeOptionsType.Sequence] = {
            name: $filter('translate')('SEQUENCE'),
            type: ECodeOptionsType.Sequence,
          };
          $scope.codeOptions[ECodeOptionsType.RevisionNumber] = {
            name: $filter('translate')('REVISION NUMBER'),
            type: ECodeOptionsType.RevisionNumber,
          };
          $scope.codeOptions[ECodeOptionsType.RevisionYear] = {
            name: $filter('translate')('REVISION NUMBER'),
            type: ECodeOptionsType.RevisionYear,
          };
          $scope.codeOptions[ECodeOptionsType.Extension] = {
            name: $filter('translate')('EXTENSION'),
            type: ECodeOptionsType.Extension,
          };
          $scope.configuration = null;

          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isSysadmin = logWrapper(
            isSysadmin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.tabTitle = logWrapper(
            tabTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.optionsFilter = logWrapper(
            optionsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.testCode = logWrapper(
            testCode,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isSignEnabled = logWrapper(
            isSignEnabled,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.currentTab = logWrapper(
            currentTab,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateTab = logWrapper(
            updateTab,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
